export default "__VITE_ASSET__de2f9967__"